<template>
  <card>
    <list v-if="$store.state.user.is_root" :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink"
      :cardLink="cardLink" :isUpdate="true" :isAdd="false" :itemLink="itemLink" :setLink="setLink" :openItem="true"
      :fields="fields" :searchDisable="false" @change="change" @changeFunction="changeFunction" v-model="val" />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      modalCreate: "client",
      fields: [

      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_client_cloud",
      itemLink: "clients",
      setLink: "clients",
      columns: [
        {
          key: "id",
          title: "Login",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_active",
          title: "",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "full_name",
          title: "Ученик",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "group",
          title: "Класс",
          object: 'title',
          disableLink: true,
        },
        {
          key: "business",
          title: "Школа",
          object: 'title',
                    disableLink: true,

        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true
        },
        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
